export const sendMetrikaEvent = (eventId: string) => {
  window.ym(63971854, 'reachGoal', eventId);
};
